module.exports = {
  definition: {
    prefix: 'fac',
    iconName: 'playlistAddCheck',
    icon: [
      24, 24,
      [],
      null,
      `M2 14h8v2H2zm0-4h12v2H2zm0-4h12v2H2zm16 4h-2v4h-4v2h4v4h2v-4h4v-2h-4z`
    ]
  }
};
